export const styleSheet = () => ({
  tableRoot: {
    height: "calc(100vh - 140px)",
    width: "100%",
    backgroundColor: "white",
    maxHeight: "800px",
    minHeight: "700px",
  },
});
